import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as zxcvbn from 'zxcvbn';

export function dropboxScoreValidator(minRequiredScore: number): ValidatorFn {
  return (control: AbstractControl): DropboxScoreError => {
    const checkScoreResult = zxcvbn(control.value);
    if (checkScoreResult.score < minRequiredScore) {
      return {
        dropboxScore: {
          requiredScore: minRequiredScore,
          actualScore: checkScoreResult.score,
        },
      };
    }

    return null;
  };
}

export interface DropboxScoreError {
  dropboxScore: {
    requiredScore: number;
    actualScore: number;
  };
}

export function hasDropboxScoreError(errors: any): errors is DropboxScoreError {
  return (errors as DropboxScoreError).dropboxScore !== undefined;
}
